import React, { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import FormBox from "../FormBox/FormBox";
import { LoadingButton } from "../../Utils/CustomComponent";
import PopupWrapper from "../PopupWrapper";
import urls from "../../Utils/urls";
import axios from "axios";
import { oracleConfig } from "../../Utils/constant";
import { commonToast } from "../../Utils";

const ChatbotTicketModal = ({ show, setShow, onTicketSuccess }) => {
  return (
    <PopupWrapper
      title={<h2 className="p-4 font-weight-bold text-dark">Create Ticket</h2>}
      extraClass="width-800"
      Component={
        <TicketComp
          close={() => setShow(false)}
          onTicketSuccess={onTicketSuccess}
        />
      }
      toShow={show}
      closeEventHandler={() => setShow(false)}
    />
  );
};

export default ChatbotTicketModal;

const createTicketFormSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      subject: Yup.string().required("Subject is mandatory"),
      incident_description: Yup.string().required("Description is mandatory"),
    })
  ),
};

const TicketComp = ({ close, onTicketSuccess }) => {
  const [loading, setLoading] = useState(false);
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm(createTicketFormSchema);

  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));

  const onSubmit = (data) => {
    setLoading(true);
    const id = toast.loading("Creating a new ticket");

    data.user_id = `${userDetails.user_id}`;
    data.contact_email = userDetails.email;
    data.status_id = "1";
    data.role_type = selectedRole;
    data.severity_id = "";
    data.urgency_id = "";
    data.department_id = "1";

    axios
      .post(urls.support.postTicket(), data, oracleConfig)
      .then((response) => {
        // console.log({ response });
        onTicketSuccess(response?.data?.incident_number);
        close();
        toast.update(id, {
          render: "Ticket Created",
          type: "success",
          isLoading: false,
          ...commonToast,
        });

        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        toast.update(id, {
          render: "SOME ERROR OCCURED",
          type: "error",
          isLoading: false,
          ...commonToast,
        });
        setLoading(false);
      });
  };

  return (
    <div className="mt-2">
      <form className="py-5 bg-white" onSubmit={handleSubmit(onSubmit)}>
        <div className="container">
          <div className="row">
            <div className="col-12 mb-4">
              <FormBox
                options={ticketFormArr}
                register={register}
                watch={watch}
                setValue={setValue}
                errors={errors}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end mt-5">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => close()}
          >
            Cancel
          </button>
          <LoadingButton
            loading={loading}
            disabled={loading}
            type="submit"
            className="btn btn-primary text-white"
            title={"Create Ticket"}
          />
        </div>
      </form>
    </div>
  );
};

const ticketFormArr = [
  { title: "Subject", field: "subject", type: "text", className: "col-12" },
  {
    title: "Description",
    field: "incident_description",
    type: "textarea",
    className: "col-12",
  },
];
